/**
 * 公司信息
 * */
export const companyInfo = {
    name: '巨擎网络科技（济南）有限公司', // 公司名称
    code: '鲁ICP备2023028652号', // 备案号
    addr: '济南市历下区高新万达写字楼J3-1502', // 地址
    zipCode: 250000, // 邮政编码
    wangAn: '鲁公网安备37010102006841号',
    wangAnLink: 'https://beian.mps.gov.cn/#/query/webSearch?code=37010102006841'
}



// WEBPACK FOOTER //
// ./resources/js/config/companyInfo.js